/* eslint-disable */
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import {  styled } from '@material-ui/core/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@material-ui/core';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import { LoadingComponent } from 'src/pages/pageLoader';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';

const DRAWER_WIDTH = 0;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 75;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(26px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: '#F9F9F9',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};
var screenCode = 'WEBNOTIFICATION';
export default function DashboardNavbar({ onOpenSidebar }) {
  //const [initialData, setInitialData] = useState([]);
  const [NotificationsPopup,setNotificationPopup] = useState(false);

  useEffect(() => {
    trackPromise(getPermissions());
  }, [])

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    //const found = permissions.filter(x => x.screenCode === 'WEBNOTIFICATION');
    const checkWebNotification = permissions.find(p => p.permissionCode == 'WEBNOTIFICATIONPOPUP');
    //setInitialData(found)
    if (checkWebNotification != null) {
      setNotificationPopup(true)
    }
  }

  return (
    <>
      <LoadingComponent />
      <RootStyle>
        <ToolbarStyle>
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} width={35} />
          </IconButton>
          {/* <Searchbar /> */}
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
            {/* <LanguagePopover /> */}
            {NotificationsPopup ? <NotificationsPopover /> : null}
            <AccountPopover />
          </Stack>
        </ToolbarStyle>
      </RootStyle>
    </>
  );
}
